export default __webpack_public_path__ + "static/media/Cycle.6cc4c2b3.png";